import React, { useRef } from 'react';
import Box from '@material-ui/core/Box';
import RemoteAutocomplete from '../molecules/RemoteAutocomplete';
import { asyncSearchForSuppliers } from '../../utils/controllers/SuppliersSearchController';

const SearchSupplier = ({ onSelectSupplier, selectedSupplier, token, originalValue }) => {
	const downshiftReference = useRef(null);

	const handleSelectSupplier = supplier => {
		onSelectSupplier(supplier);
	};

	const customListHandler = list => {
		const tmp = [];
		let parent1 = { i: -1, subs: -1 };
		let parent2 = { i: -1, subs: -1 };

		for (let i in list) {
			if (list[i].subsidiaries && list[i].subsidiaries.length > 0) {
				// if has subsidiaries add is parent flag
				tmp.push({ ...list[i], secondaryDataToDisplay: ' (parent)' });

				// check for biggest parents (parent1 & parent2)
				if (list[i].subsidiaries.length > parent1.subs) {
					if (parent1.subs > parent2.subs) parent2 = { ...parent1 };
					parent1 = { i, subs: list[i].subsidiaries.length };
				} else if (list[i].subsidiaries && (list[i].subsidiaries.length > parent2.subs)) {
					parent2 = { i, subs: list[i].subsidiaries.length };
				}
			} else if (list[i].parentOrganizations && list[i].parentOrganizations.length > 0) {
				// if has parents add is subsidiary flag
				tmp.push({ ...list[i], secondaryDataToDisplay: ' (subsidiary)' });
			} else {
				tmp.push(list[i]);
			}
		}

		// reorder the biggest parents to the beginning of the array
		if (parent2.i >= 0) tmp.unshift(tmp.splice(parent2.i, 1)[0]);
		if (parent1.i >= 0) tmp.unshift(tmp.splice(parent1.i, 1)[0]);
		return tmp;
	};

	return (
		<Box display={'inline-block'} style={{ width: '90%' }}>
			<RemoteAutocomplete
				onSelect={handleSelectSupplier}
				asyncFetchFunction={value => asyncSearchForSuppliers(token, value)}
				placeholder={originalValue ? originalValue : selectedSupplier}
				reference={downshiftReference}
				defaultValue={selectedSupplier}
				hasAddNew
				customListHandler={customListHandler}
			/>
		</Box>
	);
};

export default SearchSupplier;
